import {SeatType} from "@CheckOrder/components/MainSection/SeatPicker/types/Seat.type";

export default function getFormattedSeatNumber(seat: SeatType): string {
    const {seatNumber} = seat
    try {
        return seatNumber.split('|')?.[0]
    } catch (e) {
        return seatNumber
    }
}